<div class="w9-upload-container">
  <!-- Header -->
  <div class="w9-header">
    <div class="header-content">
      <div class="logo-section">
        <div class="logo">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm0 36c-8.837 0-16-7.163-16-16S11.163 4 20 4s16 7.163 16 16-7.163 16-16 16z"
              fill="#0075ff"
              />
            <path
              d="M20 8c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
              fill="#0075ff"
              />
            <path
              d="M20 12c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 12c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
              fill="#0075ff"
              />
          </svg>
        </div>
        <div class="company-name">{{ vendorName }}</div>
      </div>
      <div class="header-banner"></div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="w9-main-content">
    <div class="content-wrapper">
      <h1 class="main-title">Can you please upload your W9?</h1>

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-message">
          <div class="loading-spinner">
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#0075ff"
                stroke-width="2"
                fill="none"
                stroke-dasharray="31.416"
                stroke-dashoffset="31.416"
                >
                <animate
                  attributeName="stroke-dasharray"
                  dur="2s"
                  values="0 31.416;15.708 15.708;0 31.416;0 31.416"
                  repeatCount="indefinite"
                  />
                <animate
                  attributeName="stroke-dashoffset"
                  dur="2s"
                  values="0;-15.708;-31.416;-31.416"
                  repeatCount="indefinite"
                  />
              </circle>
            </svg>
          </div>
          <p class="loading-text">Loading your information...</p>
        </div>
      } @else if (uploadComplete) {
        <div class="success-message">
          <div class="success-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#28a745"
                stroke-width="2"
                fill="#d4edda"
                />
              <polyline
                points="16,8 10,14 8,12"
                stroke="#28a745"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
          </div>
          <h2 class="success-title">
            {{
              alreadyReceived
                ? "W-9 Already Received"
                : "W-9 Uploaded Successfully!"
            }}
          </h2>
          <p class="success-description">
            {{
              alreadyReceived
                ? "Your W-9 form has already been received. No further action is needed. You can now close this page."
                : "Thank you for submitting your W-9 form. You can now close this page."
            }}
          </p>
        </div>
      } @else if (linkInactive) {
        <div class="success-message">
          <div class="success-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="#dc3545"
                stroke-width="2"
                fill="#f8d7da"
                />
              <line
                x1="12"
                y1="8"
                x2="12"
                y2="13"
                stroke="#dc3545"
                stroke-width="2"
                stroke-linecap="round"
                />
              <circle cx="12" cy="16.5" r="1" fill="#dc3545" />
            </svg>
          </div>
          <h2 class="success-title">This Link Is No Longer Active</h2>
          <p class="success-description">
            This W-9 request can no longer accept uploads. If you need to
            submit a new W-9, please contact your accountant to request it
            again.
          </p>
        </div>
      } @else {
        <!-- File Upload Area -->
        <div class="upload-section">
          <div
            class="upload-area"
            [class.drag-over]="isDragOver"
            [class.has-files]="uploadedFile !== null"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()"
            >
            <div class="upload-icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                  stroke="#0075ff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  fill="none"
                  />
                <polyline
                  points="14,2 14,8 20,8"
                  stroke="#0075ff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  fill="none"
                  />
                <line
                  x1="16"
                  y1="13"
                  x2="8"
                  y2="13"
                  stroke="#0075ff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  />
                <line
                  x1="16"
                  y1="17"
                  x2="8"
                  y2="17"
                  stroke="#0075ff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  />
                <polyline
                  points="10,9 9,9 8,9"
                  stroke="#0075ff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  />
              </svg>
            </div>

            @if (uploadedFile === null) {
              <p class="upload-text">
                Drag and drop your W-9 file here, or click to select a file.
              </p>
            }

            @if (uploadedFile !== null) {
              <p class="upload-text">
                Replace the current file by dropping a new one here or clicking to
                select.
              </p>
            }

            <input
              #fileInput
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              (change)="onFileSelect($event)"
              style="display: none"
              />
          </div>

          <!-- Uploaded File Display -->
          @if (uploadedFile) {
            <div class="uploaded-files">
              <h3 class="files-title">Selected File</h3>
              <div class="file-list">
                <div class="file-item">
                  <div class="file-info">
                    <div class="file-icon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        >
                        <path
                          d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                          stroke="#0075ff"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                          />
                        <polyline
                          points="14,2 14,8 20,8"
                          stroke="#0075ff"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                          />
                      </svg>
                    </div>
                    <div class="file-details">
                      <div class="file-name">{{ uploadedFile.file.name }}</div>
                      <div class="file-size">
                        {{ formatFileSize(uploadedFile.file.size) }}
                      </div>
                    </div>
                    <div class="file-status">
                      <div
                        class="status-icon"
                        [class.success]="uploadedFile.status === 'success'"
                        [class.uploading]="uploadedFile.status === 'uploading'"
                        [class.error]="uploadedFile.status === 'error'"
                        >
                        @if (uploadedFile.status === 'success') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <polyline
                              points="20,6 9,17 4,12"
                              stroke="#28a745"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              />
                          </svg>
                        }
                        @if (uploadedFile.status === 'uploading') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#0075ff"
                              stroke-width="2"
                              fill="none"
                              />
                            <path
                              d="M12 2a10 10 0 0 1 10 10"
                              stroke="#0075ff"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                          </svg>
                        }
                        @if (uploadedFile.status === 'error') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#dc3545"
                              stroke-width="2"
                              fill="none"
                              />
                            <line
                              x1="15"
                              y1="9"
                              x2="9"
                              y2="15"
                              stroke="#dc3545"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                            <line
                              x1="9"
                              y1="9"
                              x2="15"
                              y2="15"
                              stroke="#dc3545"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                          </svg>
                        }
                      </div>
                      @if (uploadedFile.status !== 'uploading') {
                        <button
                          class="remove-btn"
                          (click)="removeFile()"
                          >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <line
                              x1="18"
                              y1="6"
                              x2="6"
                              y2="18"
                              stroke="#dc3545"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                            <line
                              x1="6"
                              y1="6"
                              x2="18"
                              y2="18"
                              stroke="#dc3545"
                              stroke-width="2"
                              stroke-linecap="round"
                              />
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                  @if (uploadedFile.status === 'uploading') {
                    <div
                      class="progress-bar"
                      >
                      <div
                        class="progress-fill"
                        [style.width.%]="uploadedFile.progress"
                      ></div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
